import React from 'react';
import { motion } from 'motion/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import styles from './ErrorBanner.module.css';
import { fadeUp } from '../../utils/motion';

export default function ErrorBanner({
  message,
  onRetry,
  retryLabel = 'Reintentar',
  className = '',
}) {
  if (!message) return null;
  return (
    <motion.div
      className={`${styles.banner} ${className}`}
      role="alert"
      aria-live="assertive"
      variants={fadeUp}
      initial="hidden"
      animate="visible"
    >
      <FontAwesomeIcon icon={faCircleExclamation} className={styles.icon} aria-hidden="true" />
      <p className={styles.text}>{message}</p>
      {onRetry && (
        <button type="button" className={styles.retry} onClick={onRetry}>
          {retryLabel}
        </button>
      )}
    </motion.div>
  );
}
